// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import {type issueUpdateArgs, updateIssuesById} from '../relay-tsq-interop'
import type {
  UpdateIssuesBulkInput,
  updateItemPickerIssueLabelsBulkMutation,
} from './__generated__/updateItemPickerIssueLabelsBulkMutation.graphql'

export function commitUpdateItemPickerIssueLabelsBulkMutation({
  environment,
  optimisticUpdateIds,
  existingIssueLabels,
  connectionIds,
  input: {ids, applyLabelIds, removeLabelIds},
  onCompleted,
  onError,
}: {
  environment: Environment
  connectionIds: {[key: string]: string[]}
  input: {ids: string[]} & issueUpdateArgs
  optimisticUpdateIds: string[]
  existingIssueLabels: Map<string, string[]>
  onCompleted?: (response: updateItemPickerIssueLabelsBulkMutation['response']) => void
  onError?: (error: Error) => void
}) {
  const inputArgs = {applyLabelIds, removeLabelIds}
  const inputHash: UpdateIssuesBulkInput = {
    ids,
    ...inputArgs,
  }

  return commitMutation<updateItemPickerIssueLabelsBulkMutation>(environment, {
    mutation: graphql`
      mutation updateItemPickerIssueLabelsBulkMutation($input: UpdateIssuesBulkInput!) @raw_response_type {
        updateIssuesBulk(input: $input) {
          jobId
        }
      }
    `,
    variables: {
      input: inputHash,
    },
    updater: store => updateIssuesById(store, optimisticUpdateIds, existingIssueLabels, connectionIds, inputArgs),
    optimisticUpdater: store =>
      updateIssuesById(store, optimisticUpdateIds, existingIssueLabels, connectionIds, inputArgs),
    onCompleted: response => onCompleted && onCompleted(response),
    onError: error => onError && onError(error),
  })
}
